"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMantelwerkstoff = exports.Mantelwerkstoff = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * Defines the material of the shealth.
 */
var Mantelwerkstoff;
(function (Mantelwerkstoff) {
    Mantelwerkstoff["TPE"] = "TPE";
    Mantelwerkstoff["igupren"] = "igupren";
    Mantelwerkstoff["iguPUR"] = "iguPUR";
    Mantelwerkstoff["PUR"] = "PUR";
    Mantelwerkstoff["PUR_ROBOT"] = "PUR_ROBOT";
    Mantelwerkstoff["PVC"] = "PVC";
    Mantelwerkstoff["SpecialMixture"] = "Spezial-Mischung";
    Mantelwerkstoff["PE"] = "PE";
    Mantelwerkstoff["None"] = "-";
})(Mantelwerkstoff = exports.Mantelwerkstoff || (exports.Mantelwerkstoff = {}));
const isMantelwerkstoff = (u) => {
    return (0, echain_shared_ts_utils_1.isValueInEnum)(Mantelwerkstoff, u);
};
exports.isMantelwerkstoff = isMantelwerkstoff;
//# sourceMappingURL=Mantelwerkstoff.js.map